import BaseCollection from "lib/collection";
import SchemaModel from "models/schema";

export default BaseCollection.extend({
    indexes: ["type"],

    url() {
        return `${this.parent.url()}/schemas`;
    },

    getByType(schemaType) {
        return this.filter(function (element) {
            return element.type === schemaType;
        });
    },

    model: SchemaModel,
});
